import type { CodecContext } from './ultrabuf.types';

const PROTOBUF_WRAPPER_INDICES = [359, 24, 22, 8132, 135];

export function withProtobufWrappers(codecContext: CodecContext): CodecContext {
    const wrappers = new Map(codecContext.wrappers);
    for (const typeIndex of PROTOBUF_WRAPPER_INDICES) {
        wrappers.set(typeIndex, {
            wrap: (data) => ({ value: data }),
            unwrap: (data: { value: unknown }) => data.value,
        });
    }

    return {
        ...codecContext,
        wrappers,
    };
}
